import React, { useState } from "react";
import Logo from "../assets/img/LogoYouka.png";
import { LuPhone } from "react-icons/lu";
import { MdOutlineMail } from "react-icons/md";
import { GrLocation } from "react-icons/gr";
import { CgWebsite } from "react-icons/cg";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
  FaStar,
} from "react-icons/fa6";
import { SiGooglemybusiness } from "react-icons/si";
import VisitCardButton from "../components/VisitCardButton";

// 🖼️ صور الكارت الأمامية والخلفية
import frontImg from "../assets/img/visitenkarte-front.png";
import backImg from "../assets/img/visitenkarte-back.png";

const VcQr = () => {
  const [flipped, setFlipped] = useState(false);

  const handleCall = () => (window.location.href = "tel:+493085968082");
  const handleFax = () => (window.location.href = "fax:+493085968082");
  const handleEmail = () => (window.location.href = "mailto:info@youka-gmbh.com");
  const redirectToWebsite = () => (window.location.href = "https://youka-gmbh.com");
  const handleMap = () =>
    window.open("https://www.google.com/maps/place/Rungestr.+13,+10179+Berlin", "_blank");

  const handleDownloadBoth = () => {
    const images = [
      { src: frontImg, filename: "Youka_Visitenkarte_Vorderseite.png" },
      { src: backImg, filename: "Youka_Visitenkarte_Rueckseite.png" },
    ];

    images.forEach((image) => {
      const link = document.createElement("a");
      link.href = image.src;
      link.download = image.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <div className="bg-white min-h-screen flex flex-col items-center justify-center text-[#103d5b] px-4 py-16">
      {/* 🔹 الشعار */}
      <img src={Logo} alt="Youka Gmbh Logo" className="w-64 mb-10 mt-10 mr-8" />

      {/* 🔹 العنوان */}
      <h1 className="text-4xl font-bold mb-6 text-center">Kontaktieren Sie uns</h1>
      <p className="max-w-2xl text-center text-lg mb-14 leading-relaxed">
        Wir freuen uns darauf, von Ihnen zu hören! Unser Unternehmen steht für Qualität, Präzision
        und Vertrauen im Bauwesen. Kontaktieren Sie uns – wir helfen Ihnen gerne weiter.
      </p>

      {/* 🔹 بيانات الاتصال */}
      <section className="w-full max-w-md mb-16 mx-auto">
        <ul className="font-semibold text-lg space-y-4 text-[#103d5b]">
          <li
            onClick={handleCall}
            className="cursor-pointer flex items-center justify-center gap-3 border-b border-gray-300 pb-3 hover:text-blue-700 transition"
          >
            <LuPhone /> +49 (0) 30 85968082
          </li>
          <li
            onClick={handleFax}
            className="cursor-pointer flex items-center justify-center gap-3 border-b border-gray-300 pb-3 hover:text-blue-700 transition"
          >
            <LuPhone /> Fax: +49 (0) 30 85968083
          </li>
          <li
            onClick={handleEmail}
            className="cursor-pointer flex items-center justify-center gap-3 border-b border-gray-300 pb-3 hover:text-blue-700 transition"
          >
            <MdOutlineMail /> info@youka-gmbh.com
          </li>
          <li
            onClick={redirectToWebsite}
            className="cursor-pointer flex items-center justify-center gap-3 border-b border-gray-300 pb-3 hover:text-blue-700 transition"
          >
            <CgWebsite /> www.youka-gmbh.com
          </li>
          <li
            onClick={handleMap}
            className="cursor-pointer flex items-center justify-center gap-3 border-b border-gray-300 pb-3 hover:text-blue-700 transition"
          >
            <GrLocation /> Rungestr. 13, 10179 Berlin
          </li>
        </ul>
      </section>

      {/* 🔹 أيقونات السوشيال ميديا */}
      <div className="flex flex-wrap justify-center gap-6 text-3xl text-[#103d5b] mb-20">
        <a href="https://www.facebook.com/youkagmbh" target="_blank" rel="noopener noreferrer">
          <FaFacebookF className="hover:text-blue-600 transition-colors" />
        </a>
        <a href="https://www.instagram.com/youkagmbh" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="hover:text-pink-600 transition-colors" />
        </a>
        <a href="https://www.tiktok.com/@youkagmbh" target="_blank" rel="noopener noreferrer">
          <FaTiktok className="hover:text-black transition-colors" />
        </a>
        <a href="https://wa.me/491604035965" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp className="hover:text-green-600 transition-colors" />
        </a>
        <a href="https://www.youtube.com/@youkagmbh" target="_blank" rel="noopener noreferrer">
          <FaYoutube className="hover:text-red-600 transition-colors" />
        </a>
        <a href="https://share.google/mOe0aR4AdyHDlkLxr" target="_blank" rel="noopener noreferrer">
          <SiGooglemybusiness className="hover:text-blue-400 transition-colors" />
        </a>
        <a
          href="https://search.google.com/local/writereview?placeid=ChIJscuryPlYPAwRUrn4oiEFTMw"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaStar className="hover:text-yellow-500 transition-colors" />
        </a>
      </div>

      {/* 🪄 بطاقة الفيزيتكارت التفاعلية */}
      <div
        className="card-container relative w-[320px] h-[500px] cursor-pointer mb-8"
        onClick={() => setFlipped(!flipped)}
      >
        <div className={`card-inner ${flipped ? "flipped" : ""}`}>
          <div className="card-front shadow-[0_15px_35px_rgba(0,0,0,0.25),_0_5px_15px_rgba(0,0,0,0.15)]
">
            <img
              src={frontImg}
              alt="Youka Vorderseite"
              className="w-full h-full object-contain rounded-2xl"
            />
          </div>
          <div className="card-back shadow-[0_15px_35px_rgba(0,0,0,0.25),_0_5px_15px_rgba(0,0,0,0.15)]
">
            <img
              src={backImg}
              alt="Youka Rückseite"
              className="w-full h-full object-contain rounded-2xl"
            />
          </div>
        </div>
      </div>

      {/* 🔘 زر التحميل */}
      <button
        onClick={handleDownloadBoth}
        className="bg-[#103d5b] text-[#d7eaf1] px-6 py-3 rounded-full shadow-lg hover:bg-[#d7eaf1] hover:text-[#103d5b] transition duration-300"
      >
        Karte herunterladen
      </button>

      {/* 🔹 زر حفظ جهة الاتصال */}
      <VisitCardButton />
    </div>
  );
};

export default VcQr;
